'use strict';

var React = require('react'),
    ShareAddButtons = require('../molecules/ShareAddButtons'),
    Button = require('../atoms/Button'),
    Icon = require('../atoms/Icon'),
    UserStore = require('../stores/UserStore'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    ContextMenuActionCreators = require('../actions/ContextMenuActionCreators'),
    ContextMenuTypes = require('../constants/ContextMenuTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    isBestOf2014Special = require('../utils/isBestOf2014Special'),
    { PropTypes } = React;

var ShareAddZine = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    zine: PropTypes.object.isRequired,
    split: PropTypes.bool
  },

  contextTypes: {
    source: React.PropTypes.string.isRequired
  },

  render() {
    var zine = this.props.zine;
    if (isBestOf2014Special(zine) && !UserStore.isMe(zine.curator)) {
      return this.renderStandaloneShareButton();
    }

    return (
      <ShareAddButtons size={this.props.size}
                       onShareClick={this.handleShareClick}
                       onAddClick={this.handleAddClick}
                       onMoreClick={this.handleMoreClick}
                       context={this.props.context}
                       showMore={this.shouldShowMore()}
                       showShare
                       split={this.props.split}
                       round={this.props.round}
                       color={this.props.color}
                       overlay={this.props.overlay} />
    );
  },

  renderStandaloneShareButton() {
    return (
      <Button size={this.props.size}
              color={this.props.color}
              fill={this.props.fill}
              overlay={this.props.overlay}
              onClick={this.handleShareClick}
              round>
        <Icon name='share'
              mode='stroke'
              size='small' />
      </Button>
    );
  },

  shouldShowMore() {
    var zine = this.props.zine;
    return UserStore.isMe(zine.curator) || zine.isSubscribed;
  },

  handleAddClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMPS_TO_ZINE, {
      zineSlug: this.props.zine.slug
    });
  },

  handleShareClick(e) {
    var el = e.target;
    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_SHARE, el, {
      zineSlug: this.props.zine.slug,
      source: this.context.source
    });
  },

  handleMoreClick(e) {
    var el = e.target,
        zine = this.props.zine;

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.ZINE_MORE, el, {
      zineSlug: zine.slug,
      isMeCurator: UserStore.isMe(zine.curator)
    });
  }
});

module.exports = ShareAddZine;



/** WEBPACK FOOTER **
 ** ./organisms/ShareAddZine.jsx
 **/